import { IOpsIntActionService, OpsIntActionResponse } from "../IOpsIntActionService";
export { OpsIntActionResponse } from "../IOpsIntActionService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export abstract class OpsIntPromiseActionService implements IOpsIntActionService {
  constructor() {
    //
  }

  abstract cancelOrder(opsIntId: string[]): Promise<OpsIntActionResponse>;
  abstract clear(
    opsIntId: string[],
    comment: string,
    externalDealId: string | null,
    options: object,
  ): Promise<OpsIntActionResponse>;
  abstract reprice(opsIntId: string[]): Promise<OpsIntActionResponse>;
  abstract resend(opsIntId: string[]): Promise<OpsIntActionResponse>;
}
